import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	zoomIn: {
		id: 'workflow-view-diagram-modal.zoom-controls.zoom-in',
		defaultMessage: 'Zoom in',
		description: 'Label for workflow editor zoom in button',
	},
	zoomOut: {
		id: 'workflow-view-diagram-modal.zoom-controls.zoom-out',
		defaultMessage: 'Zoom out',
		description: 'Label for workflow editor zoom out button',
	},
	zoomSlider: {
		id: 'workflow-view-diagram-modal.zoom-controls.zoom-slider',
		defaultMessage: 'Zoom level',
		description: 'Label for workflow editor zoom range slider',
	},
});
